module.exports = __webpack_public_path__ + "static/media/infographic1.d0e1a660.jpg";